import { hot } from "react-hot-loader/root";
import React from "react";
import { i18n } from "../utils/utils";
import Section from "./Section";

const filters = [
  { value: "last24Hours", label: i18n("Metrics.RangeLast24Hours") },
  { value: "last7Days", label: i18n("Metrics.RangeLast7Days") },
  { value: "thisMonth", label: i18n("Metrics.RangeThisMonth") },
  { value: "lastMonth", label: i18n("Metrics.RangeLastMonth") },
];

const MetricFilters = ({ onChange, current }) => {
  return (
    <ul className="filters-button">
      {filters.map((filter, f) => {
        if (filter.value === current) {
          return (
            <li className="active" key={`metricFilter${f}`}>
              {filter.label}
            </li>
          );
        }

        return (
          <li
            key={`metricFilter${f}`}
            onClick={() => {
              onChange(filter.value);
            }}
          >
            {filter.label}
          </li>
        );
      })}
    </ul>
  );
};

export default hot(MetricFilters);
